var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 4V28H1.33334V4H30.6667ZM28 6.66667H4.00001V12H28V6.66667ZM28 14.6667H25.3333V23.688L20.6667 20.888L16 23.688V14.6667H4.00001V25.3333H28V14.6667ZM22.6667 14.6667H18.6667V18.9787L20.6667 17.7787L22.6667 18.9787V14.6667Z",
    fill: "#089D49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/membership.82da89db4c6641f4984958d31f7e3f82.svg";
export { ForwardRef as ReactComponent };